import { CheckableGroup_MoreButton_default } from "./chunk-LGNOJ3DG.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioCardGroup/RadioCardGroup.MoreButton.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var RadioCardGroupMoreButton = _a => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */jsx(CheckableGroup_MoreButton_default, __spreadValues({
    className: clsx("pd:radio-card-group__more-button", className)
  }, rest));
};
var RadioCardGroup_MoreButton_default = RadioCardGroupMoreButton;
export { RadioCardGroup_MoreButton_default };